import { useT } from "../i18n";

/** Estado de comercialización (CIMA): ✓ Comercializado / ⃠ No comercializado.
 *  Icono representativo en vez de un punto. Compartido por Mis Productos y Catálogo. */
export default function MarketedBadge({ marketed }: { marketed: boolean | null | undefined }) {
  const t = useT();
  if (marketed == null) return <span style={{ color: "var(--clr-text4)" }}>—</span>;
  const color = marketed ? "#22c55e" : "#94a3b8";
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      background: color + "1e", color, border: `1px solid ${color}33`,
      borderRadius: 999, padding: "3px 10px",
      fontSize: "0.72rem", fontWeight: 600, whiteSpace: "nowrap",
    }}>
      {marketed ? (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><path d="m9 11 3 3L22 4" />
        </svg>
      ) : (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" /><path d="m4.9 4.9 14.2 14.2" />
        </svg>
      )}
      {marketed ? t("catalog.marketed") : t("catalog.notMarketed")}
    </span>
  );
}
